import { render } from "./CandlesCarousel.vue?vue&type=template&id=254cd8ce&scoped=true&lang=html"
import script from "./CandlesCarousel.vue?vue&type=script&lang=js"
export * from "./CandlesCarousel.vue?vue&type=script&lang=js"

import "./CandlesCarousel.vue?vue&type=style&index=0&id=254cd8ce&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254cd8ce"]])

export default __exports__